var map = {
	"./Mono Logo(en)_Dark.svg": "1e0b",
	"./Mono Logo(en)_Light.svg": "cad6",
	"./Mono Logo(ko)_Dark.svg": "3d81",
	"./Mono Logo(ko)_Light.svg": "f08a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "505b";